export default __webpack_public_path__ + "static/media/multi-pitch.3805e3e4.png";